import React from "react";
import { CharCount } from "../../char-count";

import type { InputProps, PathProps } from "./types";

type TextInputProps = InputProps &
  PathProps & { value?: string; errorMsg?: string; maxLength?: number };

export const SimpleTextInput: React.FC<TextInputProps> = ({
  onChange,
  basePath,
  disabled = false,
  value,
  shouldDisplayError = false,
  errorMsg,
  maxLength,
}) => {
  // For avoiding warning below, use `undefined` instead of `null`;
  // Warning: `value` prop on `input` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.
  const v = value ?? undefined;
  const isError = errorMsg && errorMsg !== "";
  const c = isError && shouldDisplayError ? "input is-danger" : "input";
  return (
    <div className="control">
      <input
        className={c}
        value={v}
        onChange={(event) => {
          onChange(basePath, event.target.value);
        }}
        disabled={disabled}
      />
      <div className="level">
        <div className="level-left">
          {isError && shouldDisplayError && (
            <p className="help has-text-weight-normal is-danger">{errorMsg}</p>
          )}
        </div>
        <div className="level-right">
          {typeof maxLength === "number" && maxLength > 0 && (
            <CharCount text={v ?? ""} maxLength={maxLength} />
          )}
        </div>
      </div>
    </div>
  );
};
